<template>
  <div class="col">
    <form :class="getClass" id="authCon" submit.prevent="validateFields()">
      <notification v-show="notification" :notification.sync="notification" class="authModule"></notification>
      <div class="container--login">
        <label for="old_password">Old Password
          <input type="password" id="old_password" name="old_password" v-model="old_password" />
          <font-awesome-icon class="displayPassword" id="password_icon" :icon="iconReturn.old_password"  @click="showPassword('old_password')"/>
        </label>

        <label for="new_password">New Password
          <input type="password" id="new_password" name="new_password" v-model="new_password" />
          <font-awesome-icon class="displayPassword" id="password_icon" :icon="iconReturn.new_password"  @click="showPassword('new_password')"/>
        </label>

        <label for="confirm_new_password">Confirm New Password
          <input type="password" id="confirm_new_password" name="confirm_new_password" v-model="confirm_new_password" />
          <font-awesome-icon class="displayPassword" id="password_icon" :icon="iconReturn.confirm_new_password"  @click="showPassword('confirm_new_password')"/>
        </label>
        <button type="submit" @click.prevent="validateFields()">Confirm</button>
      </div>
    </form>
    <p class="password--hint">
      Password must be a minimum of 8 characters. <br/>
      It must contain at least 1 number, 1 letter, and 1 special character
    </p>
  </div>
</template>

<script>
import notification from '../notification'
import { notificationTrigger } from '../../mixins/notification.js'
import { Auth } from 'aws-amplify'
import { store } from '../../store/index'

export default {
  name: 'changeNewPassword',
  data () {
    return {
      iconReturn: {
        old_password: ['far', 'eye-slash'],
        new_password: ['far', 'eye-slash'],
        confirm_new_password: ['far', 'eye-slash']
      },
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  mixins: [notificationTrigger],
  components: {
    'notification': notification
  },
  created () {
  },
  mounted () {
  },
  props: ['user'],
  computed: {
    getClass () {
      let passwordClass = this.$route.name === 'changePassword' ? 'changePassword' : 'login'
      return passwordClass
    }
  },

  methods: {
    showPassword (id) {
      let inputType = document.querySelector('#' + id).type
      if (inputType === 'password') {
        document.querySelector('#' + id).type = 'text'
        this.iconReturn[id] = ['far', 'eye']
      } else {
        document.querySelector('#' + id).type = 'password'
        this.iconReturn[id] = ['far', 'eye-slash']
      }
    },
    async validateFields () {
      let self = this
      if (self.confirm_new_password === self.new_password) {
        self.savingAnimation('reset', [])
        if (self.$route.name === 'changePassword') {
          if (self.old_password !== '') {
            let params = {'user': self.$store.state.user, 'old_password': self.old_password, 'new_password': self.new_password}
            Auth.changePassword(params.user, self.old_password, self.new_password)
              .then(response => {
                self.$router.push({name: 'profile'})
              })
              .catch(err => {
                self.savingAnimation('validate', err)
              })
            return true
          }
        } else {
          let params = {'user': self.user, 'new_password': self.new_password}
          Auth.completeNewPassword(params.user, self.new_password, params.user.challengeParam.requiredAttributes)
            .then(response => {
              store.set('user', response)
              self.$router.push({name: 'dashboard'})
            })
            .catch(err => {
              self.savingAnimation('validate', err)
            })
          return true
        }
      }
      let errors = []
      if (this.confirm_new_password !== this.new_password) errors.push('Passwords do not match.')
      if (this.old_password === '') errors.push('Please enter your old password.')
      this.savingAnimation('validate', errors)
      return false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../less/elements/color.less';
@import '../../less/utils/mixins.less';
@import '../../less/components/auth.less';
.changePassword {
  margin: 0.5rem  0;
  display: inline-block;
  width: 350px;
}
.password--hint{
  display: inline-block;
  padding-left: 15px;
  width: calc(100% - 375px);
  font-style: italic;
  vertical-align: top;
  padding-top: 3rem;
}
.authModule {
  max-width: 350px;
  position: absolute;
  top: -110px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/createNewPassword.vue